// extracted by mini-css-extract-plugin
module.exports = {"flex":"_2I1Ir","flexColumn":"cDvqq"};